import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import { MaterialFieldSettingServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
const mfssp = new MaterialFieldSettingServiceProxy()

@Component({
  components: {

  }
})
export default class Alarm extends Vue {
  extendFieldList = []
  get columns() {
    let extendCols = []
    this.extendFieldList.map(item => {
      if (item.isDisplay === 1) {
        extendCols.push({
          title: item.name,
          dataIndex: item.code,
          width: 100,
          ellipsis: true
        })
      }
    })
    return [
      {
        title: this.$t('page_material_warehousing_material_code'),
        dataIndex: 'materialCode',
        key: 'materialCode',
        width:150,
        ellipsis: true,
        customRender: (sort, _record, index) => {
          return (
            <span>
              { sort }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_warehousing_material_name'),
        dataIndex: 'materialName',
        key: 'materialName',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('page_material_warehousing_material_type'),
        dataIndex: 'materialType',
        key: 'materialType',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('page_material_warehousing_specifications'),
        dataIndex: 'standardModel',
        key: 'standardModel',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('page_business_material_1'),
        dataIndex: 'materialStuff',
        ellipsis: true,
        key: 'materialStuff',
        width: 150,
      },
      {
        title: this.$t('page_material_warehousing_unit'),
        dataIndex: 'unit',
        key: 'unit',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('page_material_ware_move_shiftNum'),
        dataIndex: 'shiftNum',
        key: 'shiftNum',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('page_material_warehousing_area'),
        dataIndex: 'fromAreaName',
        key: 'fromAreaName',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('page_material_warehousing_location'),
        dataIndex: 'fromLocationName',
        key: 'fromLocationName',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('page_material_ware_move_toArea'),
        dataIndex: 'toAreaName',
        key: 'toAreaName',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('page_material_ware_move_toLocation'),
        dataIndex: 'toLocationName',
        key: 'toLocationName',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('page_material_ware_move_remark'),
        dataIndex: 'remark',
        key: 'remark',
        width:150,
        ellipsis: true
      },
      ...extendCols
    ]
  };
  @Prop({ default: () => [] }) readonly data: Array<string>;
  @Prop({ default: false }) readonly loading: Boolean;
  @Prop({ default: 300 }) readonly height: Number;

  created(): void {
    this.getFieldSetting()
  }

  async getFieldSetting() {
    this.extendFieldList = await mfssp.get()
  }

  render() {
    return (
      <div>
        <ml-table
            pagination={false}
            columns={this.columns}
            dataSource={this.data}
            bordered
            row-key="id"
            loading={this.loading}
            scroll={{ y: this.height, x: 1650 }}
        >
        </ml-table>
      </div>
    )
  }
}
